import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatTreeModule} from '@angular/material/tree';
import {YouTubePlayerModule} from '@angular/youtube-player';
import {NbButtonModule, NbCardModule, NbIconModule, NbSpinnerModule, NbTabsetModule, NbTooltipModule} from '@nebular/theme';
import {FilterPanel, SafeHtmlPipe, SharedModule} from 'compob2b-libs';
import {TableModule} from 'compob2b-table';
import {ProductModule} from '../product/product.module';
import {CatalogListComponent} from './catalog-list/catalog-list.component';
import {CatalogRoutingModule} from './catalog-routing.module';
import {ModalCatalogComponent} from './modal-catalog/modal-catalog.component';
import { CatalogSubcategoriesComponent } from "./catalog-subcategories/catalog-subcategories.component";
import { LastCategoryComponent } from "./last-category/last-category.component";
import {ProductTableComponent} from "../product/product-table/product-table.component";
import { PluralizePipe } from "../../../../../compob2b-libs/src/lib/pipes/pluralize.pipe";
import { CatalogLevelSelectorComponent } from "./catalog-level-selector/catalog-level-selector.component";
import { CatalogMobileFilterComponent } from "./catalog-mobile-filter/catalog-mobile-filter.component";
import { FilterComponent } from "../filter-component/filter.component";

@NgModule({
  declarations: [
    CatalogListComponent, ModalCatalogComponent, CatalogSubcategoriesComponent, LastCategoryComponent,
    CatalogLevelSelectorComponent,
    CatalogMobileFilterComponent
  ],
  exports: [
    CatalogListComponent, ModalCatalogComponent,
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    NbTabsetModule,
    NbTooltipModule,
    NbSpinnerModule,
    YouTubePlayerModule,
    SharedModule,
    ReactiveFormsModule,
    TableModule,
    NbCardModule,
    NbButtonModule,
    MatTreeModule,
    ProductModule,
    NbIconModule,
    FilterPanel,
    ProductTableComponent,
    PluralizePipe,
    SafeHtmlPipe,
    FilterComponent
  ]
})
export class CatalogModule {
}
